/* eslint-disable no-console,default-case,object-shorthand,no-case-declarations,no-unused-vars,no-param-reassign,max-len */

import { reject } from 'es6-promise';
import axios from 'axios';
import { AUTH } from '../store/types';

export default ({ store, router }) => {
    /**
     * Intercept all responses
     */
    axios.interceptors.response.use(
        /**
         * Intercept success from all responses,
         * Refresh token if new one is present in the header
         * @param resp
         * @returns {*}
         */
        (resp) => {
            if (resp.headers.authorization) {
                // Clear to not have duplicated Bearer word
                const token = resp.headers.authorization.replace('Bearer ', '');
                // sessionStorage.setItem('user-token', token);
                store.dispatch(`${AUTH.namespace}${AUTH.TOKEN_REFRESH}`, token);
            }

            // return Promise.resolve(resp);
            return resp;
        },
        /**
         * Intercept errors from all responses
         * Dispatch action for error codes
         * @param err
         * @returns {Promise<never>}
         */
        (error) => {
            const originalRequest = error.config;
            const err = error.response;

            if (err) {
                if (err.status) {
                    let action;

                    switch (err.data.error) {
                        case 'invalid_credentials':
                            action = AUTH.INVALID_CREDENTIALS;
                            break;
                        case 'token_expired':
                            action = AUTH.TOKEN_EXPIRED;
                            break;
                        case 'token_invalid':
                            action = AUTH.TOKEN_INVALID;
                    }

                    if (action) {
                        store.dispatch(`${AUTH.namespace}${action}`).then((resp) => {
                            if (resp && resp.redirectTo) {
                                router.push(resp.redirectTo);
                            } else {
                                Promise.resolve(axios(originalRequest));
                            }
                        });
                    }
                }
            }

            return Promise.reject(err);
        },
    );

    /**
     * Intercept all requests,
     * add token to headers
     */
    axios.interceptors.request.use(config =>
        new Promise((resolve) => {
                const token = sessionStorage.getItem('user-token');
                config.headers.Authorization = `Bearer ${token}`;
                resolve(config);
            },
            err => reject(err.data),
        ),
    );
};



// WEBPACK FOOTER //
// ./src/util/interceptor.js